/**
 * voicePrecache — downloads all Body Scan + Breathing voice audio files into
 * the Service Worker media cache at app startup, so playback is instant
 * (and works offline) after the first launch.
 */
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;
const DONE_KEY = 'hypnose_voices_precached_v1';

export async function precacheVoices() {
  try {
    if (!('serviceWorker' in navigator) || !('caches' in window)) return;
    const reg = await navigator.serviceWorker.ready;
    if (!reg.active) return;

    const [scan, breath] = await Promise.allSettled([
      axios.get(`${API}/api/bodyscan-voices`),
      axios.get(`${API}/api/breathing-voices`)
    ]);
    const urls = new Set();
    const collect = (res) => {
      if (res.status !== 'fulfilled' || !Array.isArray(res.value.data)) return;
      res.value.data.forEach((v) => {
        const u = v.audio_url;
        if (!u) return;
        urls.add(u.startsWith('http') ? u : `${API}${u}`);
      });
    };
    collect(scan);
    collect(breath);
    if (urls.size === 0) return;

    reg.active.postMessage({ type: 'PRECACHE_MEDIA', urls: [...urls] });
    try { localStorage.setItem(DONE_KEY, new Date().toISOString()); } catch { /* noop */ }
  } catch { /* offline or SW unavailable: retry next launch */ }
}
